export default "__VITE_ASSET__DoMSTQQo__"